import { AlertMessageInterfaceState, initialAlertMessageState } from '../state/alert-message.state';
import { AlertMessageActions, EAlertMessageActions } from '../actions/alert-message.actions';

export function alertMessagesReducer(state: AlertMessageInterfaceState = initialAlertMessageState, action: AlertMessageActions): AlertMessageInterfaceState {
  switch (action.type) {
    case EAlertMessageActions.GetAlertMessage: {
      return { ...state, alert: action.payload };
    }

    default:
      return initialAlertMessageState;
  }
};
